import { ReactElement, useCallback } from 'react';
import { createFetchContext } from '../../../components/contexts/FetchContextFactory';
import { getPaginatedClassesBook as getBase } from '../api';
import {
  ClassesBookTableQuery as BaseQuery,
  ClassesBookTableResponse as Base,
} from '../types';

export const ITEMS_PER_PAGE_DEFAULT = 10;

interface BaseLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  BaseQuery,
  Base
>();

export function useClassesBookLoader() {
  const context = useFetch();
  return {
    data: context.data,
    query: context.query,
    loading: context.loading,
    updateQuery: context.updateQuery,
  };
}

export const ClassesBookLoaderConsumer = FetchConsumer;

export function ClassesBookLoader({ children }: BaseLoaderProps) {
  const request = useCallback(({ page, ...params }) => {
    return getBase({
      items_per_page: ITEMS_PER_PAGE_DEFAULT,
      page: page - 1,
      ...params,
    });
  }, []);

  return (
    <FetchProvider
      request={request}
      defaultQuery={{ page: 1 }}
      fetchImmediately
      children={children}
    />
  );
}
